export const SEARCH_TERM_PARAM_NAME = 'search-term'
export const SEARCH_LIMIT = 100
